module.exports = __webpack_public_path__ + "static/media/msd.00236b37.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/labs/msd.png
// module id = 134
// module chunks = 0